  /* eslint-disable */
  const Utils = {}

  /**
   * 生成随机len位数字
   */
  Utils.randomLenNum = function (len, date) {
    let random = ''
    random = Math.ceil(Math.random() * 100000000000000).toString().substr(0, typeof len === 'number' ? len : 4)
    if (date) random = random + Date.now()
    return random
  }

  /** 参数说明：
   * 根据长度截取先使用字符串，超长部分追加…
   * str 对象字符串
   * len 目标字节长度
   * 返回值： 处理结果字符串
   */
  Utils.cutString = (str, len) => {
    if (str.length * 2 <= len) {
      return str
    }
    let strlen = 0
    let s = ''
    for (let i = 0; i < str.length; i++) {
      // eslint-disable-line
      s += str.charAt(i)
      if (str.charCodeAt(i) > 128) {
        strlen += 2
        if (strlen >= len) {
          return `${s.substring(0, s.length - 1)}...`
        }
      } else {
        strlen += 1
        if (strlen >= len) {
          return `${s.substring(0, s.length - 2)}...`
        }
      }
    }
    return s
  }

  /**
   * 简单数组的交集
   * @param {Array} a
   * @param {Array} b
   */
  Utils.getIntersect = (a, b) => {
    if (a.constructor === Array && b.constructor === Array) {
      const set1 = new Set(a)
      const set2 = new Set(b)
      return Array.from(new Set([...set1].filter(x => set2.has(x))))
    }
    return null
  }

  /**
   * 防抖函数
   * @param {*} func 函数体
   * @param {*} wait 延时
   */
  Utils.debounce = (func, wait = 50) => {
    // 缓存一个定时器id
    let timer = 0
    // 这里返回的函数是每次用户实际调用的防抖函数
    // 如果已经设定过定时器了就清空上一次的定时器
    // 开始一个新的定时器，延迟执行用户传入的方法
    return function(...args) {
      if (timer) clearTimeout(timer)
      timer = setTimeout(() => {
        func.apply(this, args)
      }, wait)
    }
  }

  /**
   * 节流函数
   * @param {*} func 函数体
   * @param {*} wait 延时
   */
  Utils.throttle = (func, wait = 50) => {
    // 上一次执行该函数的时间
    let lastTime = 0
    return function(...args) {
      // 当前时间
      const now = +new Date()
      // 将当前时间和上一次执行函数时间对比
      // 如果差值大于设置的等待时间就执行函数
      if (now - lastTime > wait) {
        lastTime = now
        func.apply(this, args)
      }
    }
  }


  /**
   * 返回 n 位的随机字符串
   * @param {Number} n
   */
  Utils.getRandomStr = (n = 6) => {
    let str = ''
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890'
    for (let i = 0; i < n; i += 1) {
      str += chars.charAt(Math.floor(Math.random() * 62))
    }
    return str
  }

  function type(obj) {
    const { toString } = Object.prototype
    const map = {
      '[object Boolean]': 'boolean',
      '[object Number]': 'number',
      '[object String]': 'string',
      '[object Function]': 'function',
      '[object Array]': 'array',
      '[object Date]': 'date',
      '[object RegExp]': 'regExp',
      '[object Undefined]': 'undefined',
      '[object Null]': 'null',
      '[object Object]': 'object',
    }
    return map[toString.call(obj)]
  }

  function insertItem(item, arr) {
    const { order } = item
    if (typeof arr[order] !== 'number') {
      arr[order] = item
      return
    }
    let moveBegin
    let moveEnd
    let pos
    let i = order + 1

    while (arr[i]) {
      if (arr[i].order > order) {
        if (!moveBegin) {
          moveBegin = i
          pos = i
        }
      }
      i += 1
    }

    if (moveBegin) {
      moveEnd = i
    } else {
      pos = i
    }

    if (!moveEnd) {
      arr[pos] = item
      return
    }

    // 需要移动
    for (let i = moveEnd; i >= moveBegin; i -= 1) {
      arr[i + 1] = arr[i]
    }
    arr[pos] = item
  }

  /**
   * 根据数组的 order 字段排序
   * @param {Array} source
   */
  Utils.sortByOrder = (source = []) => {
    if (!Array.isArray(source)) {
      return source
    }
    const tmp = []
    let target = []

    // 将带排序的子项添加进临时数组 tmp
    for (let i = 0; i < source.length; i += 1) {
      if (typeof source[i].order !== 'number') {
        continue
      }
      let { order } = source[i]
      // 支持设置倒数顺序
      if (order < 0) {
        order = source.length + order
        if (order < 0) {
          order = 0
        }
      }

      // 确保整数
      source[i].order = Math.floor(order)

      // 插入临时数组
      insertItem(source[i], tmp)
    }

    // 合并临时数组和原数组
    for (let i = 0, j = 0; i < source.length; i += 1) {
      if (typeof source[i].order === 'number') {
        continue
      }
      // 找需要填的坑
      while (tmp[j]) {
        j += 1
      }
      tmp[j] = source[i]
    }
    // 筛除空隙
    target = tmp.filter(item => !!item)
    return target
  }


  /**
   * 深度遍历，深拷贝
   * @param {*} data
   */
  Utils.deepClone = data => {
    const t = type(data)
    let o
    let i
    let ni

    if (t === 'array') {
      o = []
    } else if (t === 'object') {
      o = {}
    } else {
      return data
    }

    if (t === 'array') {
      for (i = 0, ni = data.length; i < ni; i++) {
        // eslint-disable-line
        o.push(Utils.deepClone(data[i]))
      }
      return o
    } else if (t === 'object') {
      /* eslint-disable */
      for (i in data) {
        o[i] = Utils.deepClone(data[i])
      }
      /* eslint-enable */
      return o
    }
    return data
  }

  /**
   * 判断权限
   */
  Utils.hasPermission = (auths, route, user) => { // eslint-disable-line
    if (user && user.isSuper) {
      return true
    }
    if (route.right) {
      return auths.some(auth => route.right.indexOf(auth) > -1)
    }
    return true
  }

  export default Utils
